<script>
  import './style.scss';
  import axios from 'axios';
  import template from './template.html';
  import { RhombusIcon, CheckboxBlankCircleOutlineIcon, UploadIcon, DownloadIcon } from '../icons.js';
  import { getLanguages, getUsers, mapTargetLanguages } from '../Review-Request-Form/utils.js';
  import { keyBy } from 'lodash';
  import filesize from 'filesize';
  import moment from 'moment';

  export default {

    props: {
      taskId: {
        default: 0,
        type: Number
      },

      isReviewer: {
        default: false,
        type: Boolean
      }
    },

    async mounted () {

      this.task = await axios(`/review/task/${this.taskId}`).then(result => result.data);

      this.languages = await getLanguages().then((languages) => keyBy(languages, 'id'));
    },

    computed: {

      taskInstructions () {
        let notes = this.task.notes || '';
        return notes;
        //return notes.replace(/(<([^>]+)>)/gi, "");
      },

      dueDate () {
        return this.task.task_due_at;
      },

      taskCompleted () {
        return this.task.task_assignment.status_complete_at && this.task.status == 'complete';
      },

      taskCanceled () {
        return this.task.status == 'canceled';
      },

      navigationRoutes () {
        let routes = [{
          id: 'task',
          href: `/my-review-tasks/${this.taskId}`,
          name: 'Task',
          active: true
        }, {
          id: 'comments',
          href: `/my-review-tasks/${this.taskId}/comments`,
          name: 'Review Task Comments',
          active: false
        }];

        if (!this.isReviewer) {
          routes.push({
            id: 'edit',
            href: `/my-review-tasks/${this.taskId}/edit`,
            name: 'Edit',
            active: false
          });
        }

        return routes;
      },

    },

    methods: {

      getLanguage (id) {
        return this.languages[id] ? this.languages[id].name : '-';
      },

      getStatusColor (status) {
        const reviewStatusColors = {
          'assigned': '#1F8CEE',
          'open': '#1F8CEE',
          'complete': '#68C71E',
          'canceled': '#000000'
        };

        return reviewStatusColors[status];
      },

      convertFileSize ($size) {
        return filesize($size);
      },

      titleCase (str = '') {
        return str.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      },

      removeISO (str = '') {
        return str.replace(/ *\([^)]*\) */g, "");
      },

      closeCompleteTask () {
        return this.showTaskCompletedForm = false;
      },

      confirmCompleteTask (comment) {

        axios.post(`/my-review-tasks/${this.task.id}/status-complete`, {
          'status':'complete',
          comment
        }).then(result => {
          this.task.status = 'complete';
          this.closeCompleteTask();
        });
      },

      completeTask () {
        //decide whether to complete the task
        this.showTaskCompletedForm = true;
      },

      confirmCancel () {
        this.$modal.show('dialog', {
          title: `Confirm Task Cancellation`,
          text: `Canceled Review Tasks will not be accessible to the reviewer,
          however work may have begun on this task.  Are you sure you want
          to cancel this Review Task?`,
          buttons: [
            {
              title: 'Close',
              class: 'vue-dialog-button dialog-cancel-btn',
              handler: () => {
                this.$modal.hide('dialog')
              }
            },
            {
              title: 'Confirm',
              class: 'vue-dialog-button dialog-confirm-btn',
              handler: () => {
                //call the route to cancel the review task
                axios.post(`/my-review-tasks/${this.task.id}/status`, {'status':'canceled'})
                  .then(result => {
                    this.task.status = 'canceled';
                  })

                this.$modal.hide('dialog')
              }
            }
          ]
        });
      },
    },

    template,

    data () {

      return {

        task: {
          task_assignment: {},
          items: [],
          source_files: [],
          reference_files: [],
          feedback_files: []
        },

        showTaskCompletedForm: false,

        hi: 'hi',

        languages: {},

        taskName: 'German Review For Website UI Updates (28826)',

        status: 'Open',
      }
    },

    components: {
      RhombusIcon
      ,CheckboxBlankCircleOutlineIcon
      ,UploadIcon
      ,DownloadIcon
    }
  };
</script>
